import {
  Anchor,
  Compass,
  Gift,
  Layers,
  LifeBuoy,
  Map,
  RefreshCw,
  Route,
} from 'lucide-react';
import SectionHeader from './SectionHeader';
import { CALL_MOMENTS, EXPERT_EDGE } from '../data/callAttractionData';
import './CallAttractionSections.css';

const EDGE_ICONS = {
  layers: Layers,
  route: Route,
  refresh: RefreshCw,
  compass: Compass,
  anchor: Anchor,
  gift: Gift,
  map: Map,
  life: LifeBuoy,
};

export function ExpertEdgeSection() {
  return (
    <section className="section section--expert-edge" aria-label="Why speak with our team">
      <div className="container">
        <SectionHeader
          eyebrow={EXPERT_EDGE.eyebrow}
          title={EXPERT_EDGE.title}
          subtitle={EXPERT_EDGE.subtitle}
          light
        />
        <div className="expert-edge__stats" role="list">
          {EXPERT_EDGE.stats.map((stat) => (
            <div key={stat.label} className="expert-edge__stat" role="listitem">
              <span className="expert-edge__stat-value">{stat.value}</span>
              <span className="expert-edge__stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
        <div className="expert-edge__grid">
          {EXPERT_EDGE.edges.map((edge, index) => {
            const Icon = EDGE_ICONS[edge.icon] || Layers;
            return (
              <article
                key={edge.title}
                className="expert-edge__card"
                style={{ '--edge-i': index }}
              >
                <div className="expert-edge__card-icon" aria-hidden>
                  <Icon size={26} strokeWidth={1.85} />
                </div>
                <h3>{edge.title}</h3>
                <p>{edge.text}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export function CallMomentsSection() {
  return (
    <section className="section section--call-moments" aria-label="When to call us">
      <div className="container">
        <SectionHeader
          eyebrow={CALL_MOMENTS.eyebrow}
          title={CALL_MOMENTS.title}
          subtitle={CALL_MOMENTS.subtitle}
        />
        <div className="call-moments__grid">
          {CALL_MOMENTS.moments.map((moment, index) => (
            <article
              key={moment.num}
              className="call-moments__card"
              style={{ '--moment-i': index }}
            >
              <span className="call-moments__num" aria-hidden>
                {moment.num}
              </span>
              <h3>{moment.title}</h3>
              <p>{moment.text}</p>
            </article>
          ))}
        </div>
        <p className="call-moments__closing">{CALL_MOMENTS.closing}</p>
      </div>
    </section>
  );
}

export default function CallAttractionSections() {
  return (
    <>
      <ExpertEdgeSection />
      <CallMomentsSection />
    </>
  );
}
